<template>
  <history-stack
    :default-view-component="() => import('./LandmarkCard.vue')"
    v-bind="$attrs"
    @stack:close="handleClose"
  />
</template>

<script>
export default {
  name: 'LandmarkHistoryStack',
  setup(props, { root }) {
    const handleClose = () => {
      root.$router.push({
        name: 'landmarks'
      });
    };
    return {
      handleClose
    };
  }
};
</script>
